<style lang="scss" src='./SensorMap.scss' scoped></style>
<template src="./SensorMap.html"></template>

<script>
import MapRedFlag from "@/assets/img/ic/ic_flag_red.png";

export default {
  name: "SensorMap",
  props: {
    sensor: {
      required: false,
    },
  },
  data() {
    return {
      map: {},
      google: {},
    };
  },
  computed: {
    valid() {
      if(this.sensor.longitude && this.sensor.latitude && this.G_validateLatLong(this.sensor.latitude, this.sensor.longitude)){
        return true
      }
      return false
    },
  },
  watch: {
    sensor: function (newSensor, oldSensor) {
      if (
        newSensor &&
        oldSensor &&
        newSensor.sensor_id !== oldSensor.sensor_id
      ) {
        this.loadData();
      }
    },
  },
  methods: {
    async initMap({ latitude, longitude }) {
      const position = {
        lat: latitude,
        lng: longitude,
      };

      const mapOptions = {
        mapId: "map",
        zoom: 18,
        center: position,
        controlOptions: {
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
        },
      };

      this.map = await this.G_initMap(mapOptions);
      this.google = this.consts.Google.MAP;

      const newMark = new window.google.maps.Marker({
        position,
        icon: MapRedFlag,
      });

      if (this.map && this.google && this.google.maps) {
        newMark.setAnimation(this.google.maps.Animation.BOUNCE);
        newMark.setMap(this.map);

        // eslint-disable-next-line
        setTimeout(function () {
          newMark.setAnimation(null);
        }, 1500);
      }
    },

    loadData() {
      if (this.sensor && this.sensor.latitude) {
        if(this.G_validateLatLong(this.sensor.latitude, this.sensor.longitude)){
          this.initMap(this.sensor);
        }
      }
    },
  },

  beforeCreate() {},

  created() {},

  mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Sensors Map");
      this.$analytics.logEvent("web_sensors_map");
    }
    this.loadData();
  },
};
</script>
